import { getCookie, setCookie } from 'lib/utils/client-storage-utils';

const POPUP_MODAL_COOKIE_NAME_PREFIX = 'ew-popup-modal-shown';

export const getPopupModalCookieName = (popupId?: string) => {
  const normalizedPopupId = popupId?.replace(/[{}]/g, '').toLowerCase();

  return normalizedPopupId
    ? `${POPUP_MODAL_COOKIE_NAME_PREFIX}-${normalizedPopupId}`
    : POPUP_MODAL_COOKIE_NAME_PREFIX;
};

export const hasPopupAlreadyShown = (cookieName: string) => {
  try {
    return getCookie(cookieName) === 'true';
  } catch {
    return false;
  }
};

export const setPopupShown = (cookieName: string) => {
  try {
    setCookie(cookieName, 'true', '');
  } catch {
    // If cookies are unavailable, don't block modal behavior.
  }
};
